var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppFooter',{attrs:{"component-caching":_vm.componentCaching,"top-level-domain":_vm.topLevelDomain,"language-and-country":_vm.languageAndCountry,"categories-container":_vm.categoriesContainer}})}
var staticRenderFns = []

export { render, staticRenderFns }